interface MenuItemType {
  category: string;
  colorGroup?: string;
  hasThumbnail?: boolean;
  isPopular?: boolean;
  name?: string;
  shape?: string;
  size?: string;
  style?: string;
  textureId: number;
  textureType?: string;
  thumbnail?: string | undefined;
  type: string;
}

enum ColorGroup {
  BEIGE = 'Beiges',
  BLUE = 'Blues',
  BROWN = 'Browns',
  GRAY = 'Grays',
  GREEN = 'Greens',
  RED = 'Reds',
  DARK = 'Darks',
  MIXED = 'Mixed',
}

const TextureColorGroupLabelColors: { [key in ColorGroup]: string } = {
  [ColorGroup.BEIGE]: '#b8a480',
  [ColorGroup.BLUE]: '#1472A5',
  [ColorGroup.BROWN]: '#996633',
  [ColorGroup.GRAY]: '#808183',
  [ColorGroup.GREEN]: '#00A850',
  [ColorGroup.RED]: '#E44B3A',
  [ColorGroup.DARK]: '#1a1a19',
  [ColorGroup.MIXED]: '#77787a',
};

export { ColorGroup, MenuItemType, TextureColorGroupLabelColors };
